import {useCallback} from 'react';
import {useStepperStore, usePhotoBoxStore, useIVStore} from '@chekin/shared';
import {useModalControls} from '@chekin/guestapp-ui-kit';

function useDiscardIVModal() {
  const {resetAllIVState} = useIVStore();
  const resetPhotoBoxUploadedImage = usePhotoBoxStore(state => state.resetUploadedImage);
  const {resetIVProcess} = useStepperStore();

  const {
    isOpen: isOpenDiscardIVModal,
    closeModal: closeDiscardIVModal,
    openModal: openDiscardIVModal,
  } = useModalControls();

  const resetAllIVStates = useCallback(() => {
    resetPhotoBoxUploadedImage();
    resetIVProcess();
    resetAllIVState();
    closeDiscardIVModal();
  }, [resetPhotoBoxUploadedImage, resetIVProcess, resetAllIVState, closeDiscardIVModal]);

  return {
    isOpenDiscardIVModal,
    closeDiscardIVModal,
    openDiscardIVModal,
    resetIVProcess: resetAllIVStates,
  };
}

export {useDiscardIVModal};
